import { localValues, sessionValues } from "@/storage/browser"

// Browser storage belongs to the account that wrote it, except device
// preferences, so one account's layouts, workspace caches and session routes
// do not carry over to the next account on this browser. The owner record
// itself is a device preference.
const OWNER_KEY = "mux.workspaceOwner"
const DEVICE_KEYS = [/^mux\.theme\./, /^mux\.settings\./, /^mux:client-actor:/]
// The session token identified the account that claims the device, so it stays.
const SESSION_KEY = "mux.user.session"

/** The account this device's Mux storage belongs to, if one has claimed it. */
export function deviceStateOwner() {
  return localValues.getItem(OWNER_KEY) ?? undefined
}

/**
 * Records `account` as the owner of this device's Mux storage. When another
 * account owned it, removes that account's state first. Call it before any
 * store reads its persisted state.
 */
export function claimDeviceState(account: string) {
  const previous = localValues.getItem(OWNER_KEY)
  if (previous === account) return
  if (previous) {
    for (const store of [localValues, sessionValues]) {
      const keys: string[] = []
      for (let index = 0; index < store.length; index++) {
        const key = store.key(index)
        if (key && key !== SESSION_KEY && /^mux[.:]/.test(key) && !DEVICE_KEYS.some((pattern) => pattern.test(key))) keys.push(key)
      }
      for (const key of keys) store.removeItem(key)
    }
  }
  localValues.setItem(OWNER_KEY, account)
}
